/**
 * KAN-988: функции кабинета из /auth/me (поле features) под общим ключом
 * ['currentUser'], тем же запросом, что api_access.
 * KAN-1000: тарифов нет. Зарегистрированная функция (lib/features) открыта
 * всегда, не дожидаясь /auth/me; неизвестный код включён, только если его
 * прислал backend. Правило в lib/features.ts (isFeatureEnabled), его же зовёт меню.
 */
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { isFeatureEnabled } from '@/lib/features';

const NO_FEATURES: string[] = [];

export function useFeatures(): string[] {
  // Без деструктуризации: тесты маршрутов App подменяют useQuery пустым моком.
  return useCurrentUser()?.data?.features ?? NO_FEATURES;
}

export function useFeature(code: string): boolean {
  return isFeatureEnabled(code, useFeatures());
}
